var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-class-selector"},[_c('ClassSelector',{attrs:{"device-type":"mobile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }